import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';


const getAllProductapi = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);
        const res = await axiosInstance.get(`/product/featured?${params.toString()}`)
        // console.log("product", res)
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const getProductByCategoryapi = async (pageNumber, pageSize, search, field) => {
    try {
        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);
        const res = await axiosInstance.get(`/product/category?${params.toString()}`)
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const getProductByIdFunction = async (id) => {
    try {

        const params = new URLSearchParams();
        params.append('id', id);

        const res = await axiosInstance.get(`/product/id?${params.toString()}`)
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const getPriceRangeFunction = async (id) => {
    try {
        const res = await axiosInstance.get(`/product/pricerange`)
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

const getSuggestedProductFunction = async (id) => {
    try {
        const res = await axiosInstance.get(`/product/${id}/suggestions`)
        // toast.success("Successfully fetched!");
        // console.log("suggested product", res)
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export {
    getAllProductapi,
    getPriceRangeFunction,
    getProductByIdFunction,
    getProductByCategoryapi,
    getSuggestedProductFunction,
}